// Obj is { host, pathPatternArray }
// url is current url
// urlPattern is pattern to match from when comment was posted

interface URLPattern {
	host: string
	pathPatternArray: string[]
}

export default function checkUrlAgainstPattern(
	urlObj: URLPattern,
	urlPatternObj: URLPattern,
): boolean {
	// if not same host, return false
	if (urlObj.host !== urlPatternObj.host) {
		return false
	}

	// if not same number of nodes return false
	if (
		urlObj.pathPatternArray.length !== urlPatternObj.pathPatternArray.length
	) {
		return false
	}

	// check nodes match, if urlPatternObj node is * skip, else check that they match
	const doItemsMatch = urlPatternObj.pathPatternArray.map((subpath, index) => {
		if (subpath === "*") return true
		else if (subpath === urlObj.pathPatternArray[index]) return true
		else return false
	})

	if (doItemsMatch.indexOf(false) > -1) return false
	else return true
}
